import { ShareLocation } from "@mui/icons-material";
import { FC, RefObject } from "react";

import { SVG_MUI } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";

import { ButtonHeader } from "../../../../../right";

interface ICourseRebuildRouteDropdownTopButtonProps {
  anchorRef: RefObject<HTMLButtonElement>;
  isLoading: boolean;
  hasCustomRebuildType: boolean;
  rebuildRouteTooltip: string;
  onDefaultRebuild: () => void;
  onDropdownToggle: (event: React.MouseEvent) => void;
}

export const CourseRebuildRouteDropdownTopButton: FC<
  ICourseRebuildRouteDropdownTopButtonProps
> = ({
  anchorRef,
  isLoading,
  hasCustomRebuildType,
  rebuildRouteTooltip,
  onDefaultRebuild,
  onDropdownToggle,
}) => {
  return (
    <div className="rebuild-route-button-container">
      <FramerTooltip content={rebuildRouteTooltip}>
        <ButtonHeader onClick={onDefaultRebuild} disabled={isLoading}>
          <ShareLocation data-e2e="rebuild-route-course-svg" />
          {hasCustomRebuildType && (
            <span className="custom-rebuild-indicator">*</span>
          )}
        </ButtonHeader>
      </FramerTooltip>
      <ButtonHeader
        ref={anchorRef}
        onClick={onDropdownToggle}
        className="rebuild-route-dropdown-arrow"
        disabled={isLoading}
      >
        <SVG_MUI.ChevronDownSVG />
      </ButtonHeader>
    </div>
  );
};
